import { ProductsAttributeGroupProps } from './product-sku-attribute-group.types'
import styles from './product-sku-attribute-group.module.scss'
import cl from 'classnames'
import {
  Button,
  HorizontalLine,
  IconDelete,
  Input,
  Select,
  Text2,
  AttributeGroupType
} from '@touche-lts/panel-ui/dist'
import { ValueTagEditor } from 'components'
// import { AttributeGroupType } from 'models'
import { observer } from 'mobx-react-lite'
import { useRootStore } from 'mobx-stores/store-provider'

const ProductAttributeGroupComponent = (props: ProductsAttributeGroupProps) => {
  const { className, style, attributeGroup } = props
  const {
    productsSKUsStore: {
        editMode,
        attributeGroupTypeOptions,
        onRemoveAttributeClick,
        removeAttributeValue,
        setAttributeGroupProps,
        addAttributeValue
    }
  } = useRootStore()

  const isTypeColor = attributeGroup?.type === AttributeGroupType.COLOR

  return (
    <div className={cl(styles.container, className)} style={style}>
      <div className={styles.innerContainer}>
        {editMode ? (
          <Input
            colorPreset='dark'
            value={attributeGroup.name}
            onChange={name =>
              setAttributeGroupProps(attributeGroup.id, { name })
            }
          />
        ) : (
          <Text2 colorPreset='dark'>{attributeGroup.name}</Text2>
        )}
        {editMode ? (
          <Select<AttributeGroupType>
            colorPreset='dark'
            options={attributeGroupTypeOptions}
            noNoneOption
            value={attributeGroup.type}
            className={styles.selectRootClassName}
            onChange={type =>
              setAttributeGroupProps(attributeGroup.id, { type })
            }
          />
        ) : (
          <Text2 colorPreset='dark'>{attributeGroup.type}</Text2>
        )}

        <ValueTagEditor
          editMode={editMode}
          style={{ width: '100%', maxWidth: 'unset' }}
          onInputValueAdded={value =>
            addAttributeValue(attributeGroup.id, value)
          }
          valueTags={attributeGroup.values.map(attrValue => {
            return {
              valueName: attrValue.name,
              color: isTypeColor ? attrValue.value : undefined,
              onRemove: () =>
                removeAttributeValue(attributeGroup.id, attrValue.id)
            }
          })}
        />

        {editMode && (
          <Button
            preset='icon'
            className={styles.deleteButton}
            title='Remove attribute'
            onClick={() => onRemoveAttributeClick(attributeGroup.id)}
          >
            <IconDelete />
          </Button>
        )}
      </div>
      <HorizontalLine colorPreset='dark' style={{ marginTop: 25 }} />
    </div>
  )
}

const ProductAttributeGroup = observer(ProductAttributeGroupComponent)
export { ProductAttributeGroup }
